import { connect, type MapDispatchToProps } from 'react-redux';

import { changeSpaceName } from '../../../state/actions';
import { createConfluenceSpace } from '../../../state/actions/create-confluence-space';
import { getSuggestedKey } from '../../../state/context/selectors';
import { type State } from '../../../state/types';
import {
	getCreateSpaceDialogErrorState,
	getUserEnteredSpaceName,
	isCreatingSpace,
	isGeneratingKey,
	isUserEnteredSpaceNameInvalid,
} from '../../../state/ui/create-space/selectors';

import Footer from './index';
import { type StateProps, type DispatchProps, type OwnProps } from './types';

export const mapStateToProps = (state: State) => ({
	isCreatingSpace: isCreatingSpace(state),
	isGeneratingKey: isGeneratingKey(state),
	suggestedKey: getSuggestedKey(state),
	userEnteredSpaceName: getUserEnteredSpaceName(state),
	userEnteredSpaceNameInvalid: isUserEnteredSpaceNameInvalid(state),
	errorState: getCreateSpaceDialogErrorState(state),
});

export const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch) => ({
	onSpaceNameChanged: (value: any) => dispatch(changeSpaceName(value)),
	onCreate: () => dispatch(createConfluenceSpace()),
});

export default connect<StateProps, DispatchProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps,
	// @ts-ignore - Type 'undefined' is not assignable to type 'CreateSpaceDialogError'
	// This was added when enrolling `@atlassiansox/project-pages` into JFE local consumption
)(Footer);
